<!--<div class="pagebrk"></div>
  <printheaderview>
  </printheaderview>-->
<div class="pagebrk">
  <div class="row">
    <div class="col-print-12 padding-left-0px">
      <div class="card">
        <div class="card-header padding-left-0px border-bottom-0 padding-top-0px padding-bottom-0px"></div>
        <div class="card-body padding-top-0px padding-bottom-0px font-weight-normal">

          <div class="row">
            <div class="col-print-12 text-align-center">
              <label class="font-familyhead">Insemination</label>
              <qrcode class="padding-top-0px padding-bottom-0px qr-style5" [qrdata]="FormattedCode" [size]="90" [level]="'M'"></qrcode>
            </div>
          </div>

          <div class="col-print-12 bordertop border-bot-1px border-bottom-1px">
            <div class="row margin-left-0px margin-right-0px">
              <div class="col-print-5 margin-top-10 margin-bottom-10px">
                <div class="row margin-left-0px margin-right-0px">
                  <div class="col-print-6">
                    <label class="margin-bottom-0px font-family font-weight-normal">Patient:</label>
                  </div>
                  <div class="col-print-6">
                    <label class="margin-bottom-0px font-family float-left font-weight-bold">{{Owner}}</label>
                  </div>
                </div>
                <div class="row margin-left-0px margin-right-0px">
                  <div class="col-print-6">
                    <label class="margin-bottom-0px font-family font-weight-normal">Gender/Age:</label>
                  </div>
                  <div class="col-print-6">
                    <label class="margin-bottom-0px font-family float-left font-weight-normal">{{Gender}}/{{Age}}</label>
                  </div>
                </div>
                <div class="row margin-left-0px margin-right-0px">
                  <div class="col-print-6">
                    <label class="margin-bottom-0px font-family font-weight-normal">Patient ID:</label>
                  </div>
                  <div class="col-print-6">
                    <label class="margin-bottom-0px font-family float-left font-weight-normal">{{FormattedCode}}</label>
                  </div>
                </div>
                <div class="row margin-left-0px margin-right-0px">
                  <div class="col-print-6">
                    <label class="margin-bottom-0px font-family font-weight-normal">Infertility Type:</label>
                  </div>
                  <div class="col-print-6">
                    <label class="margin-bottom-0px font-family float-left font-weight-normal">{{Infertility}}</label>
                  </div>
                </div>
              </div>

              <div class="col-print-1"></div>

              <div class="col-print-5 margin-top-10 margin-bottom-10px">
                <div class="row margin-left-0px margin-right-0px">
                  <div class="col-print-6">
                    <label class="margin-bottom-0px font-family font-weight-normal">Cycle:</label>
                  </div>
                  <div class="col-print-6">
                    <label class="margin-bottom-0px font-family float-left font-weight-normal">{{CycleType}} ({{CycleNo}})</label>
                  </div>
                </div>
                <div class="row margin-left-0px margin-right-0px">
                  <div class="col-print-6">
                    <label class="margin-bottom-0px font-family font-weight-normal">Protocol:</label>
                  </div>
                  <div class="col-print-6">
                    <label class="margin-bottom-0px font-family float-left font-weight-normal">{{Protocol}}</label>
                  </div>
                </div>
                <div class="row margin-left-0px margin-right-0px">
                  <div class="col-print-6">
                    <label class="margin-bottom-0px font-family font-weight-normal">Protocol Start:</label>
                  </div>
                  <div class="col-print-6">
                    <label class="margin-bottom-0px font-family float-left font-weight-normal">{{Protocolst | date:'dd-MMM-yyyy'}}</label>
                  </div>
                </div>
                <div class="row margin-left-0px margin-right-0px">
                  <div class="col-print-6">
                    <label class="margin-bottom-0px font-family font-weight-normal">Protocol End:</label>
                  </div>
                  <div class="col-print-6">
                    <label class="margin-bottom-0px font-family float-left font-weight-normal">{{ProtocolEd | date:'dd-MMM-yyyy'}}</label>
                  </div>
                </div>
              </div>
            </div>
          </div>
          <div class="col-print-12">
            <div class="row margin-left-0px margin-right-0px">
              <div class="col-print-2">
                <label class="margin-bottom-0px font-family font-weight-normal"></label>
              </div>
              <div class="col-print-6">
                <label class="margin-bottom-0px font-family float-left font-weight-normal"></label>
              </div>
            </div>
          </div>
          <div class="col-print-12">
            <div class="row margin-left-0px margin-right-0px">
              <div class="col-print-6">
                <label class="margin-bottom-0px font-family font-weight-bold">Oocytes For Insemination</label>
              </div>
              <div class="col-print-6">
                <label class="margin-bottom-0px font-family float-left font-weight-normal"></label>
              </div>
            </div>
          </div>

          <div class="col-print-12">
            <div class="row margin-left-0px margin-right-0px">
              <div class="col-print-11">
                <div class="table-component margin-bottom-0px border4">
                  <div class="table-responsive">
                    <table class="table table-striped margin-left-zero">
                      <tr>
                        <th class="font-weight-normal background-primary padding-top-2px padding-bottom-2px font-family width-35px text-align-center">
                          S.No
                        </th>

                        <th class="font-weight-normal background-primary padding-top-2px padding-bottom-2px font-family width-35px text-align-center">
                          Well#
                        </th>

                        <th class="font-weight-normal background-primary text-align-center padding-top-2px padding-bottom-2px font-family">
                          OCC / Denuded
                        </th>
                        <th class="font-weight-normal background-primary text-align-center padding-top-2px padding-bottom-2px font-family">
                          Morphology
                        </th>
                        <th class="font-weight-normal background-primary text-align-center padding-top-2px padding-bottom-2px font-family">
                          Inemination Technique
                        </th>

                      </tr>
                      <tr *ngFor="let l of CurrentSingleWellInseminationByCycleController ; let RowIndex = index ">
                        <td class="font-family padding-top-2px padding-bottom-2px text-align-center">{{RowIndex+1}}</td>
                        <td class="font-family padding-top-2px padding-bottom-2px text-align-center">{{l.WellNo}}</td>
                        <td class="font-family padding-top-2px padding-bottom-2px text-align-center">{{l.OocyteQualityPre}} / {{l.OocyteQualityPost}}</td>
                        <td class="font-family padding-top-2px padding-bottom-2px text-align-center">{{l.Morphology}}</td>
                        <td class="font-family padding-top-2px padding-bottom-2px text-align-center">{{l.technique}}</td>
                      </tr>

                    </table>

                  </div>
                </div>
              </div>
            </div>
          </div>
          <div class="col-print-12">
            <div class="row margin-left-0px">
              <div class="col-print-6">
                <label class="margin-bottom-0px font-family font-weight-normal"></label>
              </div>
              <div class="col-print-6">
                <label class="margin-bottom-0px font-family float-left font-weight-normal"></label>
              </div>
            </div>
          </div>
          <div class="col-print-12">
            <div class="row margin-left-0px margin-right-0px">
              <div class="col-print-3">
                <label class="margin-bottom-0px font-family font-weight-bold">Insemination Log</label>
              </div>
              <div class="col-print-6">
                <label class="margin-bottom-0px font-family float-left font-weight-normal"></label>
              </div>
            </div>
          </div>

          <div class="col-print-12">
            <div class="row margin-left-0px margin-right-0px">
              <div class="col-print-11">
                <div class="table-component margin-bottom-0px border4">
                  <div class="table-responsive">
                    <table class="table table-striped margin-left-zero">
                      <tr>
                        <th class="font-weight-normal background-primary padding-top-2px padding-bottom-2px font-family">
                          <!--width-150px-->
                          Date &amp; Time
                        </th>
                        <th class="font-weight-normal background-primary text-align-center padding-top-2px padding-bottom-2px font-family">
                          No of times per hour
                        </th>
                        <th class="font-weight-normal background-primary padding-top-2px padding-bottom-2px font-family text-align-center">
                          <!--width-150px-->
                          Processed By
                        </th>
                        <th class="font-weight-normal background-primary text-align-center padding-top-2px padding-bottom-2px font-family">
                          Doctor
                        </th>
                        <!--<th class="font-weight-normal background-primary text-align-center padding-top-2px padding-bottom-2px font-family">
                          Processed By
                        </th>
                        <th class="font-weight-normal background-primary text-align-center padding-top-2px padding-bottom-2px font-family">
                          Details
                        </th>-->
                      </tr>
                      <tr>
                        <td class="font-family padding-top-2px padding-bottom-2px">{{InsemDate| date:'dd-MMM-yyyy'}} &amp; {{InsemTime| date: 'mediumTime'}}</td>
                        <td class="font-family padding-top-2px padding-bottom-2px text-align-center">{{NtimesInf}}</td>
                        <td class="font-family padding-top-2px padding-bottom-2px text-align-center">{{ProcessedBy}}</td>
                        <td class="font-family padding-top-2px padding-bottom-2px text-align-center">
                          <div class="">{{Doctor}}</div>
                          <div>{{Nurse}}</div>
                        </td>
                        <!--<td class="font-family padding-top-2px padding-bottom-2px text-align-center">{{ProcessedBy}}</td>
                        <td class="font-family padding-top-2px padding-bottom-2px text-align-center"></td>-->
                        <!--{{Details}}-->
                      </tr>

                    </table>

                  </div>
                </div>
              </div>
            </div>
          </div>

          <div class="col-print-12">
            <div class="row margin-left-0px">
              <div class="col-print-2">
                <label class="margin-bottom-0px font-family font-weight-normal"></label>
              </div>
              <div class="col-print-6">
                <label class="margin-bottom-0px font-family float-left font-weight-normal"></label>
              </div>
            </div>
          </div>
          <div class="col-print-12">
            <div class="row margin-left-0px margin-right-0px">
              <div class="col-print-4">
                <label class="margin-bottom-0px font-family font-weight-bold">Oocytes For Insemination</label>
              </div>
              <div class="col-print-6">
                <label class="margin-bottom-0px font-family float-left font-weight-normal"></label>
              </div>
            </div>
          </div>

          <div class="col-print-12">
            <div class="row margin-left-0px margin-right-0px">
              <div class="col-print-11">
                <div class="table-component margin-bottom-0px border4">
                  <div class="table-responsive">
                    <table class="table table-striped margin-left-zero">
                      <thead>
                        <tr>

                          <th class="font-weight-normal background-primary padding-top-2px padding-bottom-2px font-family width-35px text-align-center">
                            Well#
                          </th>

                          <th class="font-weight-normal background-primary text-align-center padding-top-2px padding-bottom-2px font-family">
                            Morphology
                          </th>
                          <th class="font-weight-normal background-primary text-align-center padding-top-2px padding-bottom-2px font-family">
                            Storage
                          </th>
                          <th class="font-weight-normal background-primary text-align-center padding-top-2px padding-bottom-2px font-family">
                            Details
                          </th>
                          <th class="font-weight-normal background-primary text-align-center padding-top-2px padding-bottom-2px font-family">
                            Status
                          </th>
                        </tr>
                      </thead>
                      <tbody>
                        <tr *ngFor="let l of CurrentIvfOocyteEmbryoStorageByCodeController">
                          <td class="font-family padding-top-2px padding-bottom-2px text-align-center">{{l.WellNo}}</td>
                          <td class="font-family padding-top-2px padding-bottom-2px text-align-center">{{l.Morphology}}</td>
                          <td class="font-family padding-top-2px padding-bottom-2px text-align-center">{{l.StorageUnitType}}</td>
                          <td class="font-family padding-top-2px padding-bottom-2px text-align-center">{{l.StorageUnitDetails}}</td>
                          <td class="font-family padding-top-2px padding-bottom-2px text-align-center">{{l.Status}}</td><!--{{l.RecordStatus}}-->
                        </tr>
                      </tbody>
                    </table>

                  </div>
                </div>
              </div>
            </div>
          </div>
          <div class="col-print-12">
            <div class="row margin-left-0px margin-right-0px">
              <div class="col-print-6">
                <label class="margin-bottom-0px font-family"></label>
              </div>
              <div class="col-print-6">
                <label class="margin-bottom-0px font-family"></label>
              </div>
            </div>
          </div>
          <div class="col-print-12">
            <div class="row margin-left-0px">
              <div class="col-print-6">
                <label class="margin-bottom-0px font-family font-weight-bold">Summary:</label>
              </div>
              <div class="col-print-6">
                <label class="margin-bottom-0px font-family float-left font-weight-normal"></label>
              </div>
            </div>
          </div>
          <div class="col-print-12">
            <div class="row margin-left-0px">

              <div class="col-print-7">
                <div class="table-component margin-bottom-0px border4">
                  <div class="table-responsive">
                    <table class="table table-striped margin-left-zero">
                      <tr>
                        <th class="font-weight-normal background-primary padding-top-2px text-align-center padding-bottom-2px font-family">
                          ICSI
                        </th>

                        <th class="font-weight-normal background-primary padding-top-2px padding-bottom-2px font-family text-align-center">
                          IMSI
                        </th>

                        <th class="font-weight-normal background-primary text-align-center padding-top-2px padding-bottom-2px font-family">
                          IVF
                        </th>
                        <th class="font-weight-normal background-primary text-align-center padding-top-2px padding-bottom-2px font-family">
                          Total
                        </th>

                      </tr>
                      <tr>
                        <td class="font-family padding-top-2px padding-bottom-2px text-align-center">{{ICSICount}}</td>
                        <td class="font-family padding-top-2px padding-bottom-2px text-align-center">{{IMSICount}}</td>
                        <td class="font-family padding-top-2px padding-bottom-2px text-align-center">{{IVFCount}}</td>
                        <td class="font-family padding-top-2px padding-bottom-2px text-align-center">{{TotalCount}}</td>
                      </tr>

                    </table>

                  </div>
                </div>
              </div>
            </div>
          </div>
          <!--<div class="col-print-12">
            <div class="row margin-left-0px margin-right-0px">
              <div class="col-print-7">
                <label class="margin-bottom-0px font-family">Surgeon</label>
              </div>
              <div class="col-print-5">
                <label class="margin-bottom-0px font-family">Assistant Surgeon</label>
              </div>
            </div>
          </div>
          <div class="col-print-12">
            <div class="row margin-left-0px margin-right-0px">
              <div class="col-print-6">
                <label class="margin-bottom-0px font-family"></label>
              </div>
              <div class="col-print-6">
                <label class="margin-bottom-0px font-family"></label>
              </div>
            </div>
          </div>
          <div class="col-print-12">
            <div class="row margin-left-0px margin-right-0px">
              <div class="col-print-7">
                <div class="row margin-left-0px margin-right-0px">
                  <div class="col-print-4 border-bot-1px">
                    <label class="margin-bottom-0px font-family text-align-center"></label>
                  </div>
                  <div class="col-print-6">
                    <label class="margin-bottom-0px font-family"></label>
                  </div>
                </div>
              </div>
              <div class="col-print-5">
                <div class="row margin-left-0px margin-right-0px">
                  <div class="col-print-6 border-bot-1px">
                    <label class="margin-bottom-0px font-family text-align-center"></label>
                  </div>
                  <div class="col-print-5">
                    <label class="margin-bottom-0px font-family"></label>
                  </div>
                </div>
              </div>
            </div>
          </div>-->

        </div>
      </div>
    </div>
  </div>
</div>
<!--<printfooterview></printfooterview>-->
